import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../../theme';
export const useStyles = () => {
    const theme = useTheme();
    return {
        activity: {
            border: `2px solid ${brandColors.borderGray}`,
            marginBottom: theme.spacing(1.5),
            padding: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,
        },
        activityName: {
            fontWeight: 900,
            marginRight: theme.spacing(0.5),
        },
        activityTable: {
            marginTop: 0,
        },
        title: {
            color: theme.palette.primary.dark,
            paddingBottom: '0.25rem',
            [theme.breakpoints.down('xs')]: {
                fontSize: '1.5rem',
            },
        },
        heading: {
            color: theme.palette.primary.dark,
        },
        tableWrapper: {
            backgroundColor: theme.palette.background.paper,
            overflow: 'auto',
            maxWidth: '100%',
        },
    };
};
